<template>
  <div class="oppo-login-page">
    <div class="login-header">
      <div class="logo-circle">🛡️</div>
      <div class="title">OPPO 服务助手</div>
      <div class="sub">激活 · 升级 · 售后一站式服务</div>
    </div>

    <div class="form-section">
      <div class="form-card">
        <div class="section-title">选择登录身份</div>
        <div class="role-selector">
          <div
            class="role-card"
            :class="{ selected: role === 'user' }"
            @click="role = 'user'"
          >
            <div class="r-icon">👤</div>
            <div class="r-name">用户</div>
            <div class="r-desc">查询门店 / 查看权益</div>
          </div>
          <div
            class="role-card"
            :class="{ selected: role === 'clerk' }"
            @click="role = 'clerk'"
          >
            <div class="r-icon">🧑‍💼</div>
            <div class="r-name">店员</div>
            <div class="r-desc">激活设备 / 售后服务</div>
          </div>
        </div>

        <div v-if="false" class="clerk-fields">
          <van-field
            v-model="clerkForm.province"
            label="选择省"
            placeholder="请选择省"
            readonly
            is-link
            required
            @click="showProvincePicker = true"
          />
          <van-field
            v-model="clerkForm.merchant"
            label="所属商家"
            placeholder="请选择所属商家"
            readonly
            is-link
            required
            @click="showMerchantPicker = true"
          />
          <van-field
            v-model="clerkForm.store"
            label="所属门店"
            placeholder="请选择所属门店"
            readonly
            is-link
            required
            @click="showStorePicker = true"
          />
        </div>

        <button class="login-btn" :class="{ loading: loading }" @click="handleLogin">
          <span v-if="!loading">登录</span>
          <van-loading v-else size="20px" color="#fff" />
        </button>
      </div>
    </div>

    <van-popup v-model="showProvincePicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择省"
        :columns="provinces"
        @confirm="onProvinceConfirm"
        @cancel="showProvincePicker = false"
      />
    </van-popup>

    <van-popup v-model="showMerchantPicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择商家"
        :columns="merchants"
        @confirm="onMerchantConfirm"
        @cancel="showMerchantPicker = false"
      />
    </van-popup>

    <van-popup v-model="showStorePicker" position="bottom">
      <van-picker
        show-toolbar
        title="选择门店"
        :columns="stores"
        @confirm="onStoreConfirm"
        @cancel="showStorePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'OppoLogin',
  data() {
    return {
      role: 'user',
      loading: false,
      showProvincePicker: false,
      showMerchantPicker: false,
      showStorePicker: false,
      clerkForm: {
        province: '',
        merchant: '',
        store: '',
      },
      provinces: ['广东省', '北京市', '上海市', '浙江省'],
      merchants: ['OPPO 深圳分公司', 'OPPO 广州分公司', 'OPPO 东莞分公司'],
      stores: ['OPPO 深圳南山旗舰店', 'OPPO 深圳福田体验店', 'OPPO 深圳宝安授权店'],
    }
  },
  methods: {
    onProvinceConfirm(val) {
      this.clerkForm.province = val
      this.showProvincePicker = false
    },
    onMerchantConfirm(val) {
      this.clerkForm.merchant = val
      this.showMerchantPicker = false
    },
    onStoreConfirm(val) {
      this.clerkForm.store = val
      this.showStorePicker = false
    },
    handleLogin() {
      // if (this.role === 'clerk') {
      //   if (!this.clerkForm.province || !this.clerkForm.merchant || !this.clerkForm.store) {
      //     this.$toast('请完善省、商家、门店信息')
      //     return
      //   }
      // }
      localStorage.setItem('oppoRole', this.role)
      if (this.role === 'clerk') {
        localStorage.setItem('oppoClerkInfo', JSON.stringify(this.clerkForm))
        this.$router.push({ path: '/Oppo/ClerkHome' })
      } else {
        this.$router.push({ path: '/Oppo/BenefitQuery' })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.oppo-login-page {
  min-height: 100vh;
  background: #f5f5f5;

  .login-header {
    padding: 80px 32px 50px;
    text-align: center;
    background: linear-gradient(135deg, #1890ff, #36cfc9);
    color: #fff;

    .logo-circle {
      width: 110px;
      height: 110px;
      background: rgba(255, 255, 255, 0.25);
      border-radius: 28px;
      margin: 0 auto 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 52px;
    }

    .title {
      font-size: 40px;
      font-weight: 700;
      margin-bottom: 12px;
    }

    .sub {
      font-size: 26px;
      opacity: 0.85;
    }
  }

  .form-section {
    padding: 24px;

    .form-card {
      background: #fff;
      border-radius: 20px;
      padding: 36px 30px 30px;

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 24px;
      }

      .role-selector {
        display: flex;
        gap: 20px;
        margin-bottom: 30px;

        .role-card {
          flex: 1;
          border: 2px solid #e8e8e8;
          border-radius: 16px;
          padding: 28px 16px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;

          &.selected {
            border-color: #1890ff;
            background: #e6f7ff;
          }

          .r-icon {
            font-size: 48px;
            margin-bottom: 10px;
          }

          .r-name {
            font-size: 28px;
            font-weight: 600;
            color: #1a1a1a;
            margin-bottom: 6px;
          }

          .r-desc {
            font-size: 22px;
            color: #999;
            line-height: 1.4;
          }
        }
      }

      .clerk-fields {
        margin-bottom: 24px;
        border: 1px solid #f0f0f0;
        border-radius: 12px;
        overflow: hidden;
      }

      .login-btn {
        width: 100%;
        padding: 28px;
        border: none;
        border-radius: 16px;
        background: linear-gradient(135deg, #1890ff, #36cfc9);
        color: #fff;
        font-size: 32px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 88px;

        &.loading {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
